import apiService from "../../api/api.service";
import { ProductsRequest, ProductsResponse } from "./products.types";

/**
 * Fetch products with filters
 */
export const fetchProducts = ({ page, per_page, section_id, seque, ...filterFields }: ProductsRequest) => {
  const filters = Object.fromEntries(
    Object.entries(filterFields).filter(([, v]) => v !== undefined),
  );
  return apiService.get<ProductsResponse>("/products", {
    params: {
      page,
      per_page,
      ...(section_id !== undefined ? { section_id } : {}),
      ...(seque !== undefined ? { seque } : {}),
      ...(Object.keys(filters).length ? { filters } : {}),
    },
  });
};